import { AllIcon, IconType } from '@mm/icons';
import {
  CommentGuardIcon,
  CustomerChatIcon,
  FacebookOptinIcon,
  InstagramCommentGuardIcon,
  InstagramLiveIcon,
  InstagramStoryMentionIcon,
  InstagramWelcomerIcon,
  LandingPageIcon,
  OptInPopupIcon,
  PageWelcomerIcon,
  ShareLinkIcon,
  SmsKeywordIcon,
} from '@mm/icons/StarterIcons';
import CommentGuardPreview from 'assets/feature-previews/comment-guard.png';
import CustomerChatPreview from 'assets/feature-previews/customer-chat.png';
import {
  UIFilterStarterKinds,
  UIFilterStarterKindType,
} from '@mm/state/model/ChatStarterModel';

export const facebookRelatedStarterKinds = [
  'comment_guard',
  'facebook_optin',
  'facebook_page_welcomer',
  'share_links',
  'landing_pages',
  'facebook_catch_all',
  'instagram_welcomer',
  'instagram_story_mention',
  'instagram_comment_guard',
  'instagram_live_comment_guard',
  'instagram_catch_all',
] as UIFilterStarterKindType[];

export function isStarterKind(s: any): s is UIFilterStarterKindType {
  return UIFilterStarterKinds.includes(s);
}

export type StarterType = {
  name: string;
  icon: IconType;
  emptyStateBanner?: {
    title: string;
    submitButtonText: string;
    imageUrl: string;
    withArrow?: boolean;
  };
};

export const starterTypeByKind: Record<UIFilterStarterKindType, StarterType> = {
  all: {
    name: 'All',
    icon: AllIcon,
  },
  comment_guard: {
    name: 'Facebook Comment Guards',
    icon: CommentGuardIcon,
    emptyStateBanner: {
      title:
        'Set up a Comment Guard to automatically message to users who comment on your FB posts',
      submitButtonText: 'Facebook Comment Guard',
      imageUrl: CommentGuardPreview,
      withArrow: true,
    },
  },
  customer_chat_widget: {
    name: 'Website Chat Widgets',
    icon: CustomerChatIcon,
    emptyStateBanner: {
      title: 'Set up a chat widget to engage with website visitors',
      submitButtonText: 'Website Chat Widget',
      imageUrl: CustomerChatPreview,
    },
  },
  facebook_optin: {
    name: 'Advanced Facebook Opt-ins',
    icon: FacebookOptinIcon,
  },
  facebook_page_welcomer: {
    name: 'Facebook Page Welcomer',
    icon: PageWelcomerIcon,
  },
  facebook_catch_all: {
    name: 'Facebook Engagements Autoresponder',
    icon: PageWelcomerIcon,
  },
  landing_pages: {
    name: 'Landing Pages',
    icon: LandingPageIcon,
  },
  share_links: {
    name: 'Share Links',
    icon: ShareLinkIcon,
  },
  instagram_link: {
    name: 'Instagram Share Links',
    icon: ShareLinkIcon,
  },
  sms_keywords: {
    name: 'SMS Keywords',
    icon: SmsKeywordIcon,
  },
  optin_popups: {
    name: 'SMS Opt-in Popups',
    icon: OptInPopupIcon,
  },
  instagram_welcomer: {
    name: 'Instagram DM Responder',
    icon: InstagramWelcomerIcon,
  },
  instagram_story_mention: {
    name: 'Instagram Story Mentions',
    icon: InstagramStoryMentionIcon,
  },
  instagram_story_reaction: {
    name: 'Instagram Story Reactions',
    icon: InstagramStoryMentionIcon,
  },
  instagram_comment_guard: {
    name: 'Instagram Comment Guard',
    icon: InstagramCommentGuardIcon,
  },
  instagram_live_comment_guard: {
    name: 'Instagram Live',
    icon: InstagramLiveIcon,
  },
  instagram_catch_all: {
    name: 'Instagram Engagements Autoresponder',
    icon: InstagramLiveIcon,
  },
};
